export const columnWidths = {
  dragHandle: '3%',
  thumbnail: '11%',
  code: '11%',
  mechanism: '11%',
  branch: '9%',
  cg1: '7%',
  cg2: '7%',
  usage: '7%',
  activeStatus: '9%',
  displayStatus: '8%',
  publicationStatus: '9%',
  actions: '8%',
};
